import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-mentorship-card',
  templateUrl: './about-mentorship-card.component.html',
  styleUrls: ['./about-mentorship-card.component.scss']
})
export class AboutMentorshipCardComponent implements OnInit {
  @Input() title: string;
  @Input() text: string;
  constructor() { }

  ngOnInit(): void {
  }

}
